import classes from "../details/styles.module.scss";
import NewConversationForm from "./NewConversationForm";
import ConversationGroups from "./conversations/ConversationGroups";
import { Button } from "@altimateai/lego";
import {
  resetNewConversation,
  updateRightPanelState,
  updateSelectedConversationId,
} from "./DbtDocsReducer";
import {
  useDbtDocsCollaborationDispatch,
  useDbtDocsCollaborationSelector,
} from "./DbtDocsCollaborationProvider";
import { CloseIcon } from "../../../assets/icons";

const DbtDocsConversationsRightPanel = () => {
  const isRightPanelOpen = useDbtDocsCollaborationSelector(
    (state) => state.isRightPanelOpen,
  );
  const selectedConversationId = useDbtDocsCollaborationSelector(
    (state) => state.selectedConversationId,
  ) as string | undefined;
  const newConversation = useDbtDocsCollaborationSelector(
    (state) => state.newConversation,
  );
  const dispatch = useDbtDocsCollaborationDispatch();

  const handleClose = () => {
    dispatch(updateRightPanelState(false));
    dispatch(updateSelectedConversationId(undefined));

    dispatch(resetNewConversation());
  };
  const isOpen =
    !!newConversation || isRightPanelOpen || selectedConversationId;
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Button
        variant="ghost"
        onClick={handleClose}
        className={classes.conversationRightPanelCloseButton}
      >
        <CloseIcon />
      </Button>

      <div className={classes.conversationRightPanel}>
        <h3>Comments</h3>
        {newConversation ? <NewConversationForm /> : <ConversationGroups />}
      </div>
    </>
  );
};

export default DbtDocsConversationsRightPanel;
